import type { ReactNode } from 'react';

type DarkSurfaceElement = 'article' | 'div';

interface DarkSurfaceProps {
  as?: DarkSurfaceElement;
  children: ReactNode;
  className?: string;
}

const BASE_CLASS_NAME = [
  'relative overflow-hidden border border-slate-800/70',
  'bg-slate-950/55 shadow-[0_18px_48px_rgba(2,6,23,0.28)]',
  'backdrop-blur-sm',
].join(' ');

export function DarkSurface({
  as: Component = 'div',
  children,
  className = '',
}: DarkSurfaceProps) {
  return (
    <Component className={`${BASE_CLASS_NAME} ${className}`.trim()}>
      {children}
    </Component>
  );
}
